import { useContext } from 'react';
import type { interfaces } from 'inversify';
import { InversifyContext } from 'context';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function useInjection<T = any>(
  identifier: interfaces.ServiceIdentifier<T>,
): T {
  const { container } = useContext(InversifyContext);

  if (!container) {
    throw new Error();
  }

  return container.get<T>(identifier);
}
